import { createRef } from "react"

export const layoutContentRef = createRef()
export const stateURLRef = createRef()
export const notificationRef = createRef()
